import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';

import Comment from './comment';
import Togglable from "../togglable";

import { filterCommentByType, filterOutArchivedComment, filterIncludedInAll } from '../../util';

function isAllowed(user, source, features) {
	return function(action, comment) {
		switch (action) {
			case "add":
				return features["add_"+comment.comment_type] || false;
			case "update":
				return features["update_all_"+comment.comment_type]
					|| (features["update_created_"+comment.comment_type] && user.id===comment.creator.id)
					|| (features["update_samesource_"+comment.comment_type] && source===comment.source)
					|| false;
			case "delete":
				return features["delete_all_"+comment.comment_type]
					|| (features["delete_created_"+comment.comment_type] && user.id===comment.creator.id)
					|| (features["delete_samesource_"+comment.comment_type] && source===comment.source)
					|| false;
			default:
				return false;
		}
	}
}

const ShowMoreComments = Togglable(({ showMoreComments }) => (
	<div className="gui-comment-btn">
		<button className="btn gui-btn" type="button" onClick={showMoreComments}>Show More</button>
	</div>
))

class Comments extends PureComponent {
	componentDidUpdate() {
		if (this.props.scroll_to_comment) {
			document.getElementById(this.props.highlighted_comment).scrollIntoView();
			this.props.finishGoToComment();
		}
	}

	render() {
		var {
			comments,
			features,
			selected_type,
			user,
			visible_comments,
			highlighted_comment,
			show_comment_menu,
			source,
			showMoreComments,
			seek,
			showCommentMenu,
			startCommentReply,
			startEditingComment,
			removeComment,
			allow_comments
		} = this.props;
		if (selected_type === "") {
			selected_type = ["course","public","personal","feedback"].filter((v)=>(features["view_all_"+v] || features["view_created_"+v])).shift()
		}

		var typeComments = selected_type === "all" ? comments.filter(filterIncludedInAll) : comments.filter(filterCommentByType(selected_type));
		var commentsPage = typeComments.slice(0, visible_comments);
		var commentElements = [];
		var commentChildren = [];
		var i = 0, j = 0;
		var checkAllowed = isAllowed(user, source, features);

		while (i<commentsPage.length) {
			commentChildren = [];

			for (j=i+1; j<commentsPage.length && commentsPage[j].parent_id === commentsPage[i].objectid; j++) {
				commentChildren.push(<Comment
					key={commentsPage[j].objectid}
					comment={commentsPage[j]}
					highlighted={highlighted_comment===commentsPage[j].objectid}
					menu_opened={show_comment_menu===commentsPage[j].objectid}
					allow_reply={checkAllowed("add", commentsPage[j])}
					allow_update={checkAllowed("update", commentsPage[j])}
					allow_delete={checkAllowed("delete", commentsPage[j])}
					seek={seek}
					showCommentMenu={showCommentMenu}
					removeComment={removeComment}
					startCommentReply={startCommentReply}
					startEditingComment={startEditingComment}
				/>);
			}

			commentElements.push(<Comment
				key={commentsPage[i].objectid}
				comment={commentsPage[i]}
				highlighted={highlighted_comment===commentsPage[i].objectid}
				menu_opened={show_comment_menu===commentsPage[i].objectid}
				allow_reply={checkAllowed("add", commentsPage[i])}
				allow_update={checkAllowed("update", commentsPage[i])}
				allow_delete={checkAllowed("delete", commentsPage[i])}
				seek={seek}
				showCommentMenu={showCommentMenu}
				removeComment={removeComment}
				startCommentReply={startCommentReply}
				startEditingComment={startEditingComment}>{commentChildren}</Comment>
			);

			i = j;
		}

		return <div className="list-group list-group-flush mb-3 mb-lg-4">
			{commentElements}
			<ShowMoreComments visible={visible_comments < typeComments.filter(filterOutArchivedComment).length} showMoreComments={showMoreComments} />
		</div>;
	}
}

export default Comments;